export const validateEmail = (value: string): string | undefined => {
  const validRegex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;

  if (!value.match(validRegex)) {
    return "Por favor, insira um e-mail válido";
  }

  return undefined
}